// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reference-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  border: 2px dashed var(--ion-color-primary);
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.reference-bar-button, .reference-bar-button-background, .reference-bar-button-pressed {
  width: 28px;
  height: 28px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  background: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.reference-bar-button:not(:first-child), .reference-bar-button-background:not(:first-child), .reference-bar-button-pressed:not(:first-child) {
  margin-left: 18px;
}

.reference-bar-button-pressed {
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.25);
}

.reference-bar-button-background {
  opacity: 0.5;
}

.reference-bar-button-container {
  display: flex;
}

img {
  height: 23px;
  width: auto;
}

ion-popover {
  --width: 93%;
}

.short-popover {
  --max-height: 65%;
}

.popover-content {
  --padding-start: var(--d-spacing-double);
  --padding-end: var(--d-spacing-double);
  --padding-top: var(--d-spacing-single);
  --padding-bottom: var(--d-spacing-double);
}

.reference-bar-popover-cancel {
  display: flex;
  justify-content: flex-end;
  padding-top: var(--d-spacing-single);
  padding-right: var(--d-spacing-single);
}

.reference-highlighted {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0% {
    filter: opacity(1);
  }
  50% {
    filter: opacity(0.2);
  }
  100% {
    filter: opacity(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/common/components/reference/reference-bar/reference-bar.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,2CAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,uCAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AACI;EACE,iBAAA;AACN;;AAGA;EAEI,6CAAA;AADJ;;AAIA;EAEI,YAAA;AAFJ;;AAKA;EACI,aAAA;AAFJ;;AAKA;EACI,YAAA;EACA,WAAA;AAFJ;;AAKA;EACI,YAAA;AAFJ;;AAKA;EACI,iBAAA;AAFJ;;AAKA;EACI,wCAAA;EACA,sCAAA;EACA,sCAAA;EACA,yCAAA;AAFJ;;AAKA;EACI,aAAA;EACA,yBAAA;EACA,oCAAA;EACA,sCAAA;AAFJ;;AAKA;EACI,wCAAA;AAFJ;;AAKA;EACI;IACI,kBAAA;EAFN;EAIE;IACI,oBAAA;EAFN;EAIE;IACI,kBAAA;EAFN;AACF","sourcesContent":[".reference-content {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    border: 2px dashed var(--ion-color-primary);\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n    border-radius: 8px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n}\n\n.reference-bar-button {\n    width: 28px;\n    height: 28px;\n    box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);\n    background: white;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n\n    &:not(:first-child) {\n      margin-left: 18px;\n    }\n}\n\n.reference-bar-button-pressed {\n    @extend .reference-bar-button;\n    box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.25);\n}\n\n.reference-bar-button-background {\n    @extend .reference-bar-button;\n    opacity: 0.5;\n}\n\n.reference-bar-button-container {\n    display: flex;\n}\n\nimg {\n    height: 23px;\n    width: auto;\n}\n\nion-popover {\n    --width: 93%;\n}\n\n.short-popover {\n    --max-height: 65%;\n}\n\n.popover-content {\n    --padding-start: var(--d-spacing-double);\n    --padding-end: var(--d-spacing-double);\n    --padding-top: var(--d-spacing-single);\n    --padding-bottom: var(--d-spacing-double);\n}\n\n.reference-bar-popover-cancel {\n    display: flex;\n    justify-content: flex-end;\n    padding-top: var(--d-spacing-single);\n    padding-right: var(--d-spacing-single);\n}\n\n.reference-highlighted {\n    animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n    0% {\n        filter: opacity(1);\n    }\n    50% {\n        filter: opacity(0.2);\n    }\n    100% {\n        filter: opacity(1);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
